"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoggerProvider = exports.useLogger = exports.LoggerContext = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const fifo_logger_1 = require("fifo-logger");
const react_1 = require("react");
const LogsHistoryModal_1 = require("../modal/LogsHistoryModal");
const PreferencesContext_1 = require("./PreferencesContext");
exports.LoggerContext = (0, react_1.createContext)(null);
function useLogger() {
    const context = (0, react_1.useContext)(exports.LoggerContext);
    if (!context) {
        throw new Error('Logger context was not found');
    }
    return context;
}
exports.useLogger = useLogger;
function LoggerProvider({ children }) {
    const { current: { general: { loggingLevel }, }, } = (0, PreferencesContext_1.usePreferences)();
    const [lastReadLogId, setLastLogId] = (0, react_1.useState)(0);
    const [logsHistory, setLogsHistory] = (0, react_1.useState)([]);
    const [isLogHistoryOpened, openLogHistory] = (0, react_1.useState)(false);
    const loggerRef = (0, react_1.useRef)(new fifo_logger_1.FifoLogger({
        onChange: (log, logs) => {
            if (log && ['warn', 'error', 'fatal'].includes(log.levelLabel)) {
                //open the log history automatically if we have warn,error, or fatal
                openLogHistory(true);
                if (log?.error) {
                    // eslint-disable-next-line no-console
                    console.error(log.error);
                }
            }
            setLogsHistory(logs.slice());
        },
    }));
    (0, react_1.useEffect)(() => {
        if (loggingLevel) {
            loggerRef.current.setLevel(loggingLevel);
        }
    }, [loggingLevel]);
    const markAsRead = (0, react_1.useCallback)(() => {
        if (logsHistory.length > 0) {
            const id = logsHistory.at(-1).id;
            setLastLogId(id);
        }
    }, [logsHistory]);
    const loggerState = (0, react_1.useMemo)(() => {
        return {
            logger: loggerRef.current,
            logsHistory,
            markAsRead,
            lastReadLogId,
        };
    }, [lastReadLogId, logsHistory, markAsRead]);
    return ((0, jsx_runtime_1.jsxs)(exports.LoggerContext.Provider, { value: loggerState, children: [isLogHistoryOpened && ((0, jsx_runtime_1.jsx)(LogsHistoryModal_1.LogsHistoryModal, { autoOpen: true, onClose: () => openLogHistory(false) })), children] }));
}
exports.LoggerProvider = LoggerProvider;
